import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout'; // Import the Layout component

const Settings = () => {
  return (
    <Layout> {/* Wrap the content with Layout */}
      <div>
        <h1>Settings</h1>
        <ul>
          <li>
            <Link to="/settings/app-settings">App Settings</Link>
          </li>
          <li>
            <Link to="/settings/vendors">Vendors</Link>
          </li>
          <li>
            <Link to="/settings/otp-management">OTP Management</Link>
          </li>
        </ul>
      </div>
    </Layout>
  );
};

export default Settings;